<template>
  <div style="background: white">
    <EducationHeader />
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
        <a-breadcrumb-item @click="onBackLevel" style="cursor:pointer">创业导师</a-breadcrumb-item>
        <a-breadcrumb-item>创业导师详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="tutorBox">
      <div class="fixedBtn">
        <a-button type="primary" @click="info">联系导师</a-button>
      </div>
      <div class="userLogo">
        <img v-if="tutorDetail.userLogo" :src="getImg(tutorDetail.userLogo)" alt="">
        <img v-else src="@/assets/img/userPhoto.jpg" alt="">
        <!-- <img style="width: 100%;height: 100%;" :src="getImg(tutorDetail.userLogo)" /> -->
      </div>
      <div class="tutorRightBox">
        <div class="tutorName">{{ tutorDetail.name }} / <dict-render :dict-obj="dictObjs['education_background']"
            v-if="tutorDetail.educationBackground" :text="tutorDetail.educationBackground"></dict-render></div>
        <div class="grayBox">
          <a-descriptions :column="3">
            <!-- <a-descriptions-item label="联系电话">{{ tutorDetail.phoneNumber }}</a-descriptions-item> -->
            <a-descriptions-item label="职称">
              <dict-render :dict-obj="dictObjs['professionalTitle']" v-if="tutorDetail.professionalTitle"
                :text="tutorDetail.professionalTitle"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="单位" :span="2">{{ tutorDetail.unitName }}</a-descriptions-item>
            <a-descriptions-item label="研究领域">
              <dict-render :dict-obj="dictObjs['research_field']" v-if="tutorDetail.researchArea"
                :text="tutorDetail.researchArea"></dict-render>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>

    </div>
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            导师简介
          </div>
        </div>
        <div class="talentContentBox">
          <div class="tutorText">
            {{ tutorDetail.personalProfile }}
          </div>
        </div>
      </div>
      <!-- <div class="talentRightBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            导师资质（证书）
          </div>
        </div>
        <div class="talentContentBox">
          <img style="width: 100%;height: 100%;" :src="getImg(tutorDetail.file)" />
        </div>
      </div> -->
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { Modal } from 'ant-design-vue';
import { dictMixin } from "@/mixins";
import EducationHeader from './educationHeader';
import { entrepreneurshipMentor } from "@/api/educationService";
import DictRender from '@/components/other/DictRender';
import { file_service } from "@/api/adminService";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';

export default {
  name: "noticeDetail",
  components: { EducationHeader, DictRender, LayoutFooter },
  mixins: [dictMixin],
  data() {
    return {
      dictNames: 'education_background,professionalTitle,research_field',
      tutorDetail: {}
    }
  },
  methods: {
    getDetail() {
      this.getAction({
        url: entrepreneurshipMentor.detail,
        params: { id: this.$route.query.id }
      }).then(res => {
        this.tutorDetail = res
      })
    },
    onBackLevel() {
      this.$router.push({
        path: "/educationService/components/entrepreneurshipMentor",
        query: { type: '创业导师' }
      })
    },
    onRollbackHome() {
      this.$router.push({
        path: "/educationService/index",
        query: { type: '首页' }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    info() {
      Modal.info({
        title: () => '请拨打下方电话联系导师！',
        content: () => ('div', {}, [
          ('p', `联系电话：${this.tutorDetail.phoneNumber}`),
        ]),
        onOk() {
          console.log('ok');
        },
      });
    }
  },
  mounted() {
    this.getDetail()
  }
}
</script>
<style lang="less" scoped>
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  background: white;
}

.tutorBox {
  position: relative;
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #dedede;

  .fixedBtn {
    position: absolute;
    right: 10%;
    top: 40%;
  }

  .userLogo {
    // position: absolute;
    // right: 85px;
    // top: 25px;
    float: left;
    overflow: hidden;
    width: 80px;
    height: 80px;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .tutorRightBox {
    float: left;
    width: 80%;
    margin-left: 25px;

    .tutorName {
      margin-bottom: 20px;
      font-size: 16px;
      color: #333;
    }

    .grayBox {
      font-size: 14px;
      color: #999;
    }
  }
}

.talentBox {
  overflow: hidden;
  width: 1200px;
  margin: 20px auto;

  .talentLeftBox {
    float: left;
    width: 100%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      border-bottom: 1px solid #dedede;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }
    }

    .talentContentBox {
      padding: 14px 0;
      width: 100%;

      .tutorText {
        font-size: 14px;
        color: #333;
        text-indent: 2em;
      }
    }
  }

  .talentRightBox {
    float: right;
    width: 28%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      border-bottom: 1px solid #dedede;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }
    }

    .talentContentBox {
      padding: 14px 10px;
      width: 100%;
      height: 200px;
    }
  }
}

:deep(.ant-descriptions-item) {
  padding-bottom: 6px;
}

:deep(.ant-descriptions-item-label) {
  font-size: 14px;
  color: #999;
}

:deep(.ant-descriptions-item-content) {
  font-size: 14px;
  color: #999;
}
</style>
